import React, { FC, useMemo } from 'react';
import fp from 'lodash/fp';

import { Stack, useDesktop, useMediaSwitch, useMobile } from 'Modules/ui3';

import { PartnersProps } from './types';
import { useSliderPagination } from '../Slider/utils';
import { partnersGlider } from './utils';
import { WITH_US_DOMAIN_PATH, WithUsPaginationElement } from '../../api';
import { SectionTitleH1 } from '../Titles';
import { SliderControls } from '../SliderControls';
import { Slider } from '../Slider';
import { PartnerSlide, PartnerSlideProps } from '../PartnerSlide';


export const Partners: FC<PartnersProps> = React.memo(props => {
    const countPerSlide = useMediaSwitch(8, 6, 2);

    const isDesktop = useDesktop();
    const isMobile = useMobile();
    const { needShowElement, disableSlider, totalElements } =
        useSliderPagination<WithUsPaginationElement>({
            path: WITH_US_DOMAIN_PATH,
            elementsViewCount: countPerSlide,
        });

    const slides = useMemo(() => fp.chunk(countPerSlide, totalElements),
        [totalElements, countPerSlide]);

    const overflowSize = useMediaSwitch(50, 22, 123);

    return (
        <Stack spacing={isDesktop ? 10 : 6} {...props}>
            <Stack direction='row' alignItems='flex-end' spacing={8}>
                <SectionTitleH1>С нами уже работают</SectionTitleH1>
                {!(isMobile || disableSlider) && (
                    <SliderControls
                        glider={partnersGlider}
                        slidesCount={slides.length}
                    />
                )}
            </Stack>
            <Slider<PartnerSlideProps>
                glider={partnersGlider}
                slideComponent={PartnerSlide}
                slidesData={slides}
                disabled={disableSlider}
                needShow={needShowElement}
                overflowSizePx={overflowSize}
                rowDirection={disableSlider}
            />
        </Stack>
    );
});
